import {
  GET_LIST,
  GET_LIST_SUCCESS,
  GET_LIST_FAILURE,
  GET_LOGIN_ERROR,
} from "./actionTypes";

export const getList = () => ({
  type: GET_LIST,
});

// API Response
export const getListSuccess = (data: any): { type: string; payload: any } => ({
  type: GET_LIST_SUCCESS,
  payload: data,
});

export const getListFailure = (): { type: string } => ({
  type: GET_LIST_FAILURE,
});

export const getLoginError = (): { type: string } => ({
  type: GET_LOGIN_ERROR,
});
